module.exports = {
	app: null,
	islogin: true,
	userinfo: null,
	schoolsinfo: [],
}


//////////////////
// WEBPACK FOOTER
// ./src/js/public_object.js
// module id = 7
// module chunks = 0